'use strict'
import home from '../home/home.vue';
import company_profile from '../company_profile/company_profile.vue';
import company_product_introduction from '../company_product_introduction/company_product_introduction.vue';
import product_case from '../product_case/product_case.vue';
import joinus from '../joinus/joinus.vue';


//module.exports = {
//  name: 'navfds',
//  computed: {
////      cartInfos() {
////          return this.$store.getters.getInfos;
////      }
//  },
//  methods: {
////      clear_db() {
////          this.$store.dispatch('clear_local');
////      }
// }
// 
//}

export default {
  name: 'navfds',
  data () {
	    return {
	      navid: 0,
	      footerid: 0
	    }
	},
  components: {
	    Home:home,
	    company_profile:company_profile,
	    company_product_introduction:company_product_introduction,
	    product_case:product_case,
	    joinus:joinus
	},
	methods: {
		/**
		 * navid: 公司简介：1，公司产品介绍：2，案例：3，加盟信息：4，主页-home：0*/
		onSelectNav(e){
			console.log('navid=='+e.srcElement.dataset.navid)
			let navid = e.srcElement.dataset.navid
			console.log("6666================")
			console.log(this.navid)
			this.navid = navid
			console.log('navid=='+this.navid)
		},
		onSelectFooter(e){
			let footerid = e.srcElement.dataset.footerid
			this.footerid = footerid
		}
	},
}


// WEBPACK FOOTER //
// ./src/components/navfds/navfds.js